<template>
  <RouterLink :to="route" :exact="exact">
    <slot />
  </RouterLink>
</template>

<script>
export default {
  name: 'LangRouterLink',
  props: {
    to: {
      type: Object,
      required: true,
    },
    exact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    route() {
      const copy = Object.assign({}, this.to)
      if (copy.name.includes(':')) {
        copy.name = copy.name.substring(0, copy.name.indexOf(':'))
      }
      const locale = this.$i18n.locale.value || this.$i18n.locale
      if (locale !== this.$defaultLang) {
        copy.name += `:${locale}`
      }
      return copy
    },
  },
}
</script>
